import React from 'react';
import { useMemo } from 'react';

export interface SidebarItemProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: React.ReactNode;
  selected: boolean;
  className?: string;
  identifier: string;
  title: string;
  open?: boolean;
  indent?: number;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export default function SidebarItem({
  onClick,
  children,
  selected,
  className = 'mx-4',
  identifier,
  title,
  open = true,
  indent = 0,
  onMouseEnter,
  onMouseLeave,
}: SidebarItemProps) {
  const selectedStyle = useMemo(() => {
    if (selected) {
      return 'bg-primary-50 text-primary-700 stroke-primary-700 hover:bg-primary-100 hover:text-primary-800 hover:stroke-primary-800';
    }

    return 'hover:bg-gray-100 text-black hover:text-gray-700 hover:stroke-gray-700';
  }, [selected]);

  return (
    <button
      style={{ marginLeft: (open ? 16 : 8) + (open ? indent * 16 : 0) }}
      className={`my-1 min-h-[36px] px-3 py-2 ${className} ${selectedStyle} flex cursor-pointer items-center gap-2 text-nowrap rounded-2 text-sm font-medium`}
      role='menuitem'
      onClick={onClick}
      data-testid={identifier}
      title={title}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </button>
  );
}
